<template>
    <Modal :backdrop="true">
        <template #main>
            <div class="grid grid-cols-3 gap-2">
                <div class="col-span-2 flex flex-col ">
                    <div class="font-bold pb-2">Ricerca</div>
                    <div class="relative flex items-center">
                        <input v-model="ricerca.text" placeholder="Cerca"
                               class="pr-2 py-2 pl-11 bg-next-gray-md w-full">
                        <i class="icon-lente absolute left-0 ml-3"></i>
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="font-bold pb-2">Settore commerciale</div>
                    <VueMultiselect :searchable="true" :loading="settoriAutocomplete.isLoading" :internal-search="false"
                                    trackBy="descrizione" label="descrizione"
                                    @search-change="settoriAutocomplete.search"
                                    v-model="settoriAutocomplete.selection" :options="settoriAutocomplete.options"
                                    :multiple="true"
                                    :close-on-select="false" :clear-on-select="false" class="next-vue-multiselect"
                                    placeholder="Settore commerciale" deselectLabel="Deseleziona"
                                    selectedLabel="Selezionato"
                                    selectLabel="Seleziona">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                        <template v-slot:noOptions>Digita per cercare</template>
                        <template v-slot:tag="{ option, remove }">
                            <MultiselectOption @remove="remove(option)">
                                {{ option.descrizione }}
                            </MultiselectOption>
                        </template>
                    </VueMultiselect>
                </div>

                <div class="col-span-2 flex gap-2">

                    <div class="basis-1/2 flex flex-col">
                        <div class="font-bold pb-2">Business Unit</div>
                        <VueMultiselect :searchable="true" :loading="buAutocomplete.isLoading" :internal-search="false"
                                        trackBy="id" label="label" @search-change="buAutocomplete.search"
                                        v-model="buAutocomplete.selection" :options="buAutocomplete.options"
                                        :multiple="true"
                                        :close-on-select="false" :clear-on-select="false"
                                        class="next-vue-multiselect"
                                        placeholder="Business Unit" deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:tag="{ option, remove }">
                                <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.label || '&nbsp;' }}</span>
                                    <span>{{ option.nome }}</span>
                                </MultiselectOption>
                            </template>
                            <template v-slot:option="{ option, props }">
                                <span class="relative inline-block p-2 group">
                                    <span class="mr-2 border border-next p-1">{{ option.label }}</span><span
                                    class="mr-1">{{ option.nome }}</span>
                                </span>
                            </template>
                        </VueMultiselect>
                    </div>
                    <div class="basis-1/2 flex flex-col">
                        <div class="font-bold pb-2">Stato</div>
                        <VueMultiselect :searchable="true" :internal-search="true" trackBy="id" label="label"
                                        v-model="stato_select" :options="stato_options" :close-on-select="true"
                                        :clear-on-select="true" class="next-vue-multiselect-single" placeholder="Stato">
                        </VueMultiselect>
                    </div>
                </div>


                <div class="col-start-1 flex flex-col">
                    <div class="font-bold pb-2">Responsabili</div>
                    <VueMultiselect :searchable="true" :loading="responsabileAutocomplete.isLoading"
                                    :internal-search="false" trackBy="id" label="nome"
                                    @search-change="responsabileAutocomplete.search"
                                    v-model="responsabileAutocomplete.selection"
                                    :options="responsabileAutocomplete.options" :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false" class="next-vue-multiselect" placeholder="Responsabili"
                                    deselectLabel="Deseleziona" selectedLabel="Selezionato" selectLabel="Seleziona">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                        <template v-slot:noOptions>Digita per cercare</template>
                        <template v-slot:tag="{ option, remove }">
                            <MultiselectOption @remove="remove(option)">
                                <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                    {{ option.bu_label || '&nbsp;' }}</span>
                                <span>{{ option.name }}</span>
                            </MultiselectOption>
                        </template>

                        <template v-slot:option="{ option }">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                        </template>
                    </VueMultiselect>
                </div>


                <div class="flex flex-col">
                    <div class="font-bold pb-2">Presentazione</div>
                    <VueMultiselect v-model="presentazioneAutocomplete.selection"
                                    :options="presentazioneAutocomplete.options" :multiple="true"
                                    @search-change="presentazioneAutocomplete.search" :close-on-select="false"
                                    placeholder="Presentazione" deselectLabel="Deseleziona" selectedLabel="Selezionato"
                                    selectLabel="Seleziona" class="next-vue-multiselect" track-by="id" label="name">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                        <template v-slot:noOptions>Digita per cercare</template>
                        <template v-slot:tag="{ option, remove }">
                            <MultiselectOption @remove="remove(option)">
                                <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                    {{ option.bu_label || '&nbsp;' }}</span>
                                <span>{{ option.name }}</span>
                            </MultiselectOption>
                        </template>

                        <template v-slot:option="{ option }">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                        </template>
                    </VueMultiselect>
                </div>

                <div class="flex flex-col">
                    <div class="font-bold pb-2">Account</div>
                    <VueMultiselect :searchable="true" :loading="accountsAutocomplete.isLoading"
                                    :internal-search="false" trackBy="id" label="nome"
                                    @search-change="accountsAutocomplete.search"
                                    v-model="accountsAutocomplete.selection" :options="accountsAutocomplete.options"
                                    :multiple="true" :close-on-select="false" :clear-on-select="false"
                                    class="next-vue-multiselect"
                                    placeholder="Account" deselectLabel="Deseleziona" selectedLabel="Selezionato"
                                    selectLabel="Seleziona">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                        <template v-slot:noOptions>Digita per cercare</template>
                        <template v-slot:tag="{ option, remove }">
                            <MultiselectOption @remove="remove(option)">
                                <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                    {{ option.bu_label || '&nbsp;' }}</span>
                                <span>{{ option.name }}</span>
                            </MultiselectOption>
                        </template>

                        <template v-slot:option="{ option }">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                        </template>
                    </VueMultiselect>
                </div>

                <div class="flex flex-col">
                    <div class="font-bold pb-2">Contatti</div>
                    <VueMultiselect :searchable="true" :loading="contattoAutocomplete.isLoading"
                                    :internal-search="false" trackBy="id" label="nome"
                                    @search-change="contattoAutocomplete.search"
                                    v-model="contattoAutocomplete.selection" :options="contattoAutocomplete.options"
                                    :multiple="true" :close-on-select="false" :clear-on-select="false"
                                    class="next-vue-multiselect"
                                    placeholder="Contatti" deselectLabel="Deseleziona" selectedLabel="Selezionato"
                                    selectLabel="Seleziona">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                        <template v-slot:noOptions>Digita per cercare</template>
                        <template v-slot:tag="{ option, remove }">
                            <MultiselectOption>{{ option.nome }} {{ option.cognome }}</MultiselectOption>
                        </template>
                    </VueMultiselect>
                </div>

                <div class="col-span-2 flex flex-col">
                    <div class="font-bold pb-2">Ultimo contatto</div>
                    <div class="flex gap-2">
                        <input v-model="ricerca.ultimo_contatto_da" :max="ricerca.ultimo_contatto_a" type="date"
                               class="p-2 bg-next-gray-md w-full">
                        <input v-model="ricerca.ultimo_contatto_a" :min="ricerca.ultimo_contatto_da" type="date"
                               class="p-2 bg-next-gray-md w-full">
                    </div>
                </div>

                <div class="col flex flex-col">
                    <div class="font-bold pb-2">Nazionalità</div>
                    <VueMultiselect :searchable="true" :loading="nazioniAutocomplete.isLoading"
                                    :internal-search="false"
                                    trackBy="id" label="nome"
                                    @search-change="nazioniAutocomplete.search"
                                    @update:model-value="sanitizeNationality($event)"
                                    :model-value="nazioniAutocomplete.selection" :options="nazioniAutocomplete.options"
                                    :multiple="true" :close-on-select="false" :clear-on-select="false"
                                    class="next-vue-multiselect-single"
                                    placeholder="Nazioni" deselectLabel="Deseleziona" selectedLabel="Selezionato"
                                    selectLabel="Seleziona">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                        <template v-slot:noOptions>Digita per cercare</template>
                        <template v-slot:tag="{ option, remove }">
                            <MultiselectOption @remove="remove(option)">
                                <span>{{ option.nome }}</span>
                            </MultiselectOption>
                        </template>
                    </VueMultiselect>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-end">
                <div class="flex justify-end pt-3">
                    <NextButton variant="outline-secondary" @click="$emit('reject')" class="col-start-3 py-2 px-4">
                        Chiudi
                    </NextButton>
                    <NextButton variant="primary" @click="$emit('confirm', ricerca)" class="ml-4 py-2 px-4">
                        Cerca
                    </NextButton>
                </div>
            </div>
        </template>
    </Modal>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Loading from "@/components/Loading.vue";
import Modal from "@/components/Modal.vue";
import Autocomplete from "@/setup/Autocomplete";
import settoriManager from "../api/Settori";
import businessUnitsManager from "../api/BusinessUnits";
import contattiManager from "../api/Contatti";
import userManager from "../api/Users";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import MultiselectOption from "@/components/MultiselectOption.vue";
import NextButton from "@/components/NextButton.vue";
import {filterNazioneManager} from "@/api/Citta";


@Options({
    name: 'CercaModal',
    components: {
        NextButton,
        Modal,
        Loading,
        MultiselectOption
    },
    props: {
        settori_initial: {
            type: Array,
            default: () => []
        },
        responsabili_initial: {
            type: Array,
            default: () => []
        },
        presentazioni_initial: {
            type: Array,
            default: () => []
        },
        accounts_initial: {
            type: Array,
            default: () => []
        },
        bu_initial: {
            type: Array,
            default: () => []
        },
        contatti_initial: {
            type: Array,
            default: () => []
        },
        nazioni_initial: {
            type: Array,
            default: () => [
                -1,
            ]
        },
        stato_initial: {
            type: Number,
            default: null
        },
        ultimo_contatto_da_initial: {
            type: String,
            default: null
        },
        ultimo_contatto_a_initial: {
            type: String,
            default: null
        },
        text_initial: {
            type: String,
            default: ''
        },
    }
})
export default class CercaModal extends Vue {
    settori_initial!: any[]
    contatti_initial!: any[]
    accounts_initial!: any[]
    presentazioni_initial!: any[]
    responsabili_initial!: any[]
    nazioni_initial!: any[]
    bu_initial!: any[]
    text_initial!: string
    stato_initial!: string | number
    ultimo_contatto_da_initial!: string
    ultimo_contatto_a_initial!: string

    settoriAutocomplete: any = setup(() => Autocomplete(settoriManager, true))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, true, {crm: 1}))
    contattoAutocomplete: any = setup(() => Autocomplete(contattiManager, true))
    presentazioneAutocomplete: any = setup(() => Autocomplete(userManager, true))
    responsabileAutocomplete: any = setup(() => Autocomplete(userManager, true))
    accountsAutocomplete: any = setup(() => Autocomplete(userManager, true))
    nazioniAutocomplete: any = setup(() => Autocomplete(filterNazioneManager, true))

    @Watch('settoriAutocomplete.selection', {deep: true})
    settori(new_value: any, old: any) {
        this.ricerca.settori = new_value.map((e: any) => e.id)
    }

    @Watch('responsabileAutocomplete.selection', {deep: true})
    responsabili(new_value: any, old: any) {
        this.ricerca.responsabili = new_value.map((e: any) => e.id)
    }

    @Watch('accountsAutocomplete.selection', {deep: true})
    accounts(new_value: any, old: any) {
        this.ricerca.accounts = new_value.map((e: any) => e.id)
    }

    @Watch('buAutocomplete.selection', {deep: true})
    bu(new_value: any, old: any) {
        this.ricerca.bu = new_value.map((e: any) => e.id)
    }

    @Watch('contattoAutocomplete.selection', {deep: true})
    contatti(new_value: any, old: any) {
        this.ricerca.contatti = new_value.map((e: any) => e.id)
    }

    @Watch('presentazioneAutocomplete.selection', {deep: true})
    presentazioni(new_value: any, old: any) {
        this.ricerca.presentazioni = new_value.map((e: any) => e.id)
    }

    @Watch('nazioniAutocomplete.selection', {deep: true})
    aziende_estere(new_value: any[], old: any) {
        this.ricerca.aziende_estere = new_value.map((e: any) => e.id);
    }

    sanitizeNationality(newSelection: any) {
        let newMapped = newSelection.map((e: any) => e.id);
        let newIndexOfTutteNazioni = newMapped.indexOf(-1);
        let newIndexOfTutteNazioniEstere = newMapped.indexOf(-2);
        let oldSelection = this.nazioniAutocomplete.selection;
        let oldMapped = oldSelection.map((e: any) => e.id);
        let oldIndexOfTutteNazioni = oldMapped.indexOf(-1);
        let oldIndexOfTutteNazioniEstere = oldMapped.indexOf(-2);
        let value = newSelection;

        if (newSelection.length === 0) {
            value = [
                {id: -1, nome: 'Tutte le nazioni'}
            ];
        } else
        // (Tutte le nazioni) C'è nel nuovo, ma non c'era nel vecchio
        if (newIndexOfTutteNazioni !== -1 && oldIndexOfTutteNazioni === -1) {
            value = [
                {id: -1, nome: 'Tutte le nazioni'}
            ];
        } else
            // (Nazioni estere) C'è nel nuovo, ma non c'era nel vecchio
        if (newIndexOfTutteNazioniEstere !== -1 && oldIndexOfTutteNazioniEstere === -1) {
            value = [
                {id: -2, nome: "Tutte le nazioni estere"}
            ];

        } else
            // (Tutte le nazioni) Non c'è nel nuovo, ma c'era nel vecchio
        if (newIndexOfTutteNazioni === -1 && oldIndexOfTutteNazioni !== -1) {
            value = newSelection.filter((e: any) => e.id !== -1);
        } else
            // (Nazioni estere) Non c'è nel nuovo, ma c'era nel vecchio
        if (newIndexOfTutteNazioniEstere === -1 && oldIndexOfTutteNazioniEstere !== -1) {
            value = newSelection.filter((e: any) => e.id !== -2);
        } else
            // (Tutte le nazioni) C'è nel nuovo e c'era nel vecchio
        if (newIndexOfTutteNazioni !== -1 && oldIndexOfTutteNazioni !== -1) {
            value = newSelection.filter((e: any) => e.id !== -1);
        } else
            // (Tutte le nazioni) C'è nel nuovo e c'era nel vecchio
        if (newIndexOfTutteNazioniEstere !== -1 && oldIndexOfTutteNazioniEstere !== -1) {
            value = newSelection.filter((e: any) => e.id !== -2);
        } else {
            value = newSelection
        }

        this.nazioniAutocomplete.selection = value;
    }

    @Watch('stato_select')
    stato(new_value: any, old: any) {
        this.ricerca.stato = new_value?.id
    }

    created() {
        this.buAutocomplete.search('', 0)
        this.settoriAutocomplete.retrieveAll(this.settori_initial)
        this.contattoAutocomplete.retrieveAll(this.contatti_initial)
        this.accountsAutocomplete.retrieveAll(this.accounts_initial)
        this.presentazioneAutocomplete.retrieveAll(this.presentazioni_initial)
        this.responsabileAutocomplete.retrieveAll(this.responsabili_initial)
        this.nazioniAutocomplete.retrieveAll(this.nazioni_initial)
        this.buAutocomplete.retrieveAll(this.bu_initial)
        this.ricerca.text = this.text_initial
        this.ricerca.stato = this.stato_initial
        this.ricerca.ultimo_contatto_da = this.ultimo_contatto_da_initial
        this.ricerca.ultimo_contatto_a = this.ultimo_contatto_a_initial
        // this.ricerca.aziende_estere = 'tutti';
        this.stato_select = this.stato_options.find(e => e.id == this.stato_initial)
        this.ricerca.stato = this.stato_select?.id
    }

    ricerca: any = {
        text: this.text_initial,
        settori: [],
        responsabili: [],
        presentazioni: [],
        accounts: [],
        bu: [],
        stato: null,
        contatti: [],
        ultimo_contatto_a: null,
        ultimo_contatto_da: null,
        aziende_estere: [],
    }

    stato_select: any = null
    stato_options = [
        {id: 0, label: 'NEU'},
        {id: 1, label: 'PRO'},
        {id: 2, label: 'PRE'},
        {id: 3, label: 'BRI'},
        {id: 4, label: 'ATP'},
        {id: 5, label: 'ATT'},
    ]
}
</script>


<style lang="scss"></style>
